import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { formValueSelector } from 'redux-form';

const Props = {
  selected: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  requirements: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
};

// when it is a single selected it's a {} when multiple it's a [{}, {}]
// children is all the questions now
const EnableWhen = ({ selected = [], requirements = [], children }) => {
  let disabled = false;

  // check if the question has an enable when condition
  if (requirements.length > 0) {
    disabled = true;

    // display is the value for the enable when condition
    const { display } = requirements[0].answerCoding;

    // execute this when you have requirements and the user has selected an answer option
    if (selected.length > 0) {
      // valid is an array of all values of display where requirements = answer by user (selected)
      const valid = selected.filter(item => item.display === display);

      // disabled is equal to true if the valid.length (array length) is 0
      // if the array has nothign in it then length = 0 so disable the questions
      disabled = valid.length === 0;
    }
  } else {
    // else show the questions
    disabled = false;
  }
  return (
    // if disabled is true, then don't show question, otherwise show question
    <React.Fragment>{disabled ? null : children}</React.Fragment>
  );
};

EnableWhen.propTypes = Props;

export default connect((state, props) => {
  const groupId = state.router.location.pathname.substr(-1);
  const { enableWhenOptions = [] } = props;
  // map item to the EnableWhenOptions question condition
  let linkIds = enableWhenOptions.map(item => item.question);

  // map item to the EnableWhenOptions answerCoding display (value shown on page) condition
  const answerCodings = enableWhenOptions.map(item => item.answerCoding.display);

  if (linkIds.length > 0) {
    linkIds = [`${groupId}${linkIds}`];
  }

  // selector gets the form values
  const selector = formValueSelector('DTT');

  // selected is the form value if the enablewhen conditions are present (length > 0)
  let selected =
    linkIds.length > 0 && answerCodings.length > 0
      ? selector(state, ...linkIds)
      : [];

  // if the user hasn't selected an answer yet then make the selected variable an empty arry
  if (selected === undefined) {
    selected = [];
    // if the user has selected an answer (automatically an object), wrap object(s) into an array
  } else if (selected.length === undefined) {
    selected = [selected];
  }

  // return the user selected answer and the requirements array (enable when)
  return {
    selected,
    requirements: enableWhenOptions,
  };
})(EnableWhen);



// WEBPACK FOOTER //
// ./src/containers/EnableWhen/EnableWhen.js